$( document ).ready(function() {

    $('#range').on('change', function() {
        
        $('.charts-container').addClass('d-none');

        console.log('.charts-'+$('#range').val());
        $('.charts-'+$('#range').val()).removeClass('d-none');

        console.log('d');

    });

    $('.chart').each(function() {
        new Chart(document.getElementById($(this).attr('id')), {
            type: 'bar',
            data: {
                labels: $(this).data('labels'),
                datasets: [{
                    label: 'Dataset 1',
                    data: $(this).data('values'),
                    backgroundColor: [
                        '#e0417f'
                    ]
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                layout: {
                    padding: 0
                },
                plugins: {
                    legend: {
                        display: true,
                        position: 'bottom',
                    },
                    tooltips: {
                        enabled: false
                     }
                },
                scaleShowValues: true,
                scales: {
                    xAxes: [{
                        ticks: {
                            autoSkip: false
                        }
                    }]
                 }
            }
        });
    });

    $('.pie').each(function() {
        new Chart(document.getElementById($(this).attr('id')), {
            type: 'pie',
            data: {
                labels: $(this).data('labels'),
                datasets: [{
                    label: 'Dataset 1',
                    data: $(this).data('values'),
                    backgroundColor: [
                        '#e0417f',
                        '#f05e97',
                        '#f6bcd3',
                        '#f88ab5',
                        '#f674a7',
                        '#e24d87',
                        '#cd2768',
                        '#941647'
                    ]
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                layout: {
                    padding: 0
                },
                plugins: {
                    legend: {
                        display: true,
                        position: 'bottom',
                    }
                }
            }
        });
    });

});

